/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCryptoTaxStatements} from '../api'

 export const useQueryGetCryptoTaxStatements = createReactQueryHook('getCryptoTaxStatements', getCryptoTaxStatements)
